import React from 'react';

export const StatusBadge = ({ status, subtext }) => {
  const colors = {
    '1': 'bg-green-100 text-green-800',
    '0': 'bg-red-100 text-red-800',
    'Green': 'bg-green-100 text-green-800',
    'Yellow': 'bg-yellow-100 text-yellow-800',
    'Red': 'bg-red-100 text-red-800'
  };

  return (
    <div className="flex flex-col">
      <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium w-fit ${colors[status] || 'bg-gray-100 text-gray-800'}`}>
        {status === 1 ? "Connected" : "Disconnected"}
      </span>
      {subtext && <span className="text-xs text-gray-500 mt-1">{subtext}</span>}
    </div>
  );
};